import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../../core/context/AuthContext";
import axios from "axios";
import Swal from "sweetalert2";
import { getImageUrl } from "../../utils/imageUrl";

const Profile = () => {
  const { user, login } = useAuth();
  const fileInputRef = useRef(null);
  
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    username: "",
    password: "",
  });

  const [profilePreview, setProfilePreview] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    if (user) {
      setFormData({
        name: user.name || "",
        email: user.email || "",
        phone: user.phone || "",
        username: user.username || "",
        password: "",
      });
      if (user.profileImage) {
        setProfilePreview(getImageUrl(user.profileImage));
      }
    }
  }, [user]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedFile(file);
      setProfilePreview(URL.createObjectURL(file));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const data = new FormData();
      data.append("name", formData.name);
      data.append("email", formData.email);
      data.append("phone", formData.phone);
      data.append("username", formData.username);
      if (formData.password) data.append("password", formData.password);
      if (selectedFile) data.append("profileImage", selectedFile);

      const res = await axios.put(`https://avastar-pos-backend.onrender.com/api/users/${user._id}`, data, {
        headers: { "Content-Type": "multipart/form-data" }
      });
      login(res.data);
      Swal.fire("Success", "Profile updated successfully!", "success");
      setFormData({ ...formData, password: "" });
      setSelectedFile(null);
    } catch (err) {
      Swal.fire("Error", err.response?.data?.message || "Failed to update profile", "error");
    }
  };

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="page-title">
            <h4>My Profile</h4>
            <h6>Manage your account details and password</h6>
          </div>
        </div>
        <div className="card">
          <div className="card-body">
            <div className="profile-set">
              <div className="profile-head"></div>
              <div className="profile-top">
                <div className="profile-content">
                  <div className="profile-contentimg" style={{ position: 'relative', cursor: 'pointer' }} onClick={() => fileInputRef.current?.click()}>
                    {profilePreview ? (
                      <img 
                        src={profilePreview} 
                        alt="Profile" 
                        style={{ 
                          width: '100px', height: '100px', borderRadius: '50%', 
                          objectFit: 'cover', border: '3px solid #4361ee' 
                        }} 
                      />
                    ) : (
                      <div className="avatar-letter bg-primary text-white rounded-circle d-flex align-items-center justify-content-center fw-bold" 
                        style={{ width: '100px', height: '100px', fontSize: '2.5rem' }}>
                        {user?.name?.charAt(0) || 'U'}
                      </div>
                    )}
                    <div style={{
                      position: 'absolute', bottom: '0', right: '0',
                      background: '#4361ee', borderRadius: '50%',
                      width: '30px', height: '30px', display: 'flex',
                      alignItems: 'center', justifyContent: 'center',
                      border: '2px solid #fff', color: '#fff', fontSize: '12px'
                    }}>
                      <i className="fas fa-camera"></i>
                    </div>
                    <input
                      type="file"
                      ref={fileInputRef}
                      onChange={handleImageChange}
                      accept="image/*"
                      style={{ display: 'none' }}
                    />
                  </div>
                  <div className="profile-contentname">
                    <h2>{user?.name || 'User'}</h2>
                    <h4>{user?.role || 'Role'}</h4>
                  </div>
                </div>
              </div>
            </div>
            
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-lg-6 col-sm-12">
                  <div className="input-blocks">
                    <label className="form-label">Full Name</label>
                    <input type="text" className="form-control" name="name" value={formData.name} onChange={handleChange} required />
                  </div>
                </div>
                <div className="col-lg-6 col-sm-12">
                  <div className="input-blocks">
                    <label className="form-label">User Name</label>
                    <input type="text" className="form-control" name="username" value={formData.username} onChange={handleChange} placeholder="Optional username" />
                  </div>
                </div>
                <div className="col-lg-6 col-sm-12">
                  <div className="input-blocks">
                    <label>Email</label>
                    <input type="email" className="form-control" name="email" value={formData.email} onChange={handleChange} required />
                  </div>
                </div>
                <div className="col-lg-6 col-sm-12">
                  <div className="input-blocks">
                    <label className="form-label">Phone</label>
                    <input type="text" className="form-control" name="phone" value={formData.phone} onChange={handleChange} placeholder="+1234567890" />
                  </div>
                </div>
                
                <div className="col-lg-6 col-sm-12">
                  <div className="input-blocks">
                    <label className="form-label">New Password</label>
                    <div className="pass-group">
                      <input
                        type={showPassword ? "text" : "password"}
                        className="pass-input form-control"
                        name="password"
                        value={formData.password}
                        onChange={handleChange}
                        placeholder="Leave blank to keep current password"
                      />
                      <span 
                        className={`fas toggle-password ${showPassword ? 'fa-eye' : 'fa-eye-slash'}`} 
                        onClick={() => setShowPassword(!showPassword)}
                        style={{ cursor: 'pointer' }}
                      />
                    </div>
                  </div>
                </div>
                
                <div className="col-12 mt-3">
                  <button type="submit" className="btn btn-submit me-2">
                    Save Changes
                  </button>
                  <Link to="/" className="btn btn-cancel">
                    Cancel
                  </Link>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
